import PropTypes from "prop-types"
import { Button } from "@mui/material"
import "./view-modified-actions.scss"

// onSaveAsView is omitted (not just a no-op) when the custom-graph feature is off; Reset still works standalone.
export default function ViewModifiedActions({ onReset, onSaveAsView }) {
  return (
    <div className="graph-view-modified-actions">
      <Button size="small" onClick={onReset}>Reset</Button>
      {onSaveAsView && <Button size="small" onClick={onSaveAsView}>Save as view…</Button>}
    </div>
  )
}

ViewModifiedActions.propTypes = {
  onReset: PropTypes.func.isRequired,
  onSaveAsView: PropTypes.func,
}
